module.exports = __webpack_public_path__ + "static/img/login_bg3.8c1104c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginLuobei/img/login_bg3.jpg
// module id = e19r
// module chunks = 202